export default __webpack_public_path__ + "static/media/DSC_0564.57bb74e5.jpg";